import {ClickableStarRating} from "@components/elements/ClickableStarRating";
import React from "react";

export function StarRatingFilter(props: { min: number, onChange: (e: number) => void, max: number, className: string, step: number, placeholder: string, value: number, onReset: () => void }) {
    return <div className={[props.className, "flex flex-col items-center justify-center",].join(' ')}>
        <div className="flex items-center justify-between">
            <div className="flex items-center">
                <ClickableStarRating
                    rating={props.value}
                    onChange={props.onChange}
                    maxRating={props.max}
                    step={props.step}
                    onReset={props.onReset}
                />
            </div>
        </div>
    </div>;
}